var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 30,
    viewBox: "0 0 64 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22280",
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H54.4338C54.7851 0 55.1106 0.184299 55.2913 0.485504L63.3826 13.971C63.7626 14.6044 63.7626 15.3956 63.3826 16.029L55.2913 29.5145C55.1106 29.8157 54.7851 30 54.4338 30H1.76619C0.988895 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#B9E08F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.c8b6292b0f2f7448430e5495b71f6c22.svg";
export { ForwardRef as ReactComponent };